import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { BitrateOptions, VgApiService } from '@videogular/ngx-videogular/core';

import { environment } from '../../../environments/environment';
import { VgHlsDirective } from '@videogular/ngx-videogular/streaming';

export interface IMediaStream {
  type: 'hls';
  source: string;
  label: string;
  token?: string;
}

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit {
  @ViewChild(VgHlsDirective, { static: true }) vgHls: VgHlsDirective;

  currentStream: IMediaStream;

  private isMediaLoaded: boolean;

  api: VgApiService;

  bitrates: BitrateOptions[];

  streams: IMediaStream[] = null;

  constructor() {
    this.currentStream = null;
    this.isMediaLoaded = false;
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;
  }

  ngOnInit() {}

  setBitrate(option: BitrateOptions) {
    this.vgHls.setBitrate(option);
  }

  playStream(
    stream: IMediaStream,
    skipToInSeconds: number = 0,
    autoPlay: boolean = false,
    token: string
  ) {
    this.api.pause();
    this.bitrates = null;

    const url = environment.streamUrl + '/station';
    const username = environment.apiToken;
    const password = '?';

    this.vgHls.vgHlsHeaders = {
      Authorization: 'Bearer ' + token
    };

    /* Dont block the main thread */
    const timer: Subscription = TimerObservable.create(10, 0).subscribe(() => {
      this.isMediaLoaded = false;
      this.currentStream = stream;

      const loadedData: Subscription = this.api
        .getDefaultMedia()
        .subscriptions.loadedData.subscribe(() => {
          this.isMediaLoaded = true;
          this.api.getDefaultMedia().currentTime = skipToInSeconds;
          if (autoPlay) {
            this.api.play();
          }
          loadedData.unsubscribe();
        });

      timer.unsubscribe();
    });
  }

  play() {
    if (this.api && this.api.play) {
      this.api.play();
    }
  }

  pause() {
    if (this.api && this.api.pause) {
      this.api.pause();
    }
  }

  stop() {
    if (this.api && this.api.unregisterMedia) {
      this.api.unregisterMedia(this.api.getDefaultMedia());
    }
  }

  isPlaying(): boolean {
    const playing: boolean =
      this.isMediaLoaded &&
      this.api &&
      this.api.state &&
      this.api.state === 'playing';
    return playing;
  }
}
